/** Armazenamento mínimo compatível com localStorage; falhas são toleradas. */
export interface ArmazenamentoUsoMenuV2 {
  getItem(chave: string): string | null;
  setItem(chave: string, valor: string): void;
}

interface RegistroUso {
  vezes: number;
  ultimo: number;
}

const DIA_MS = 86400000;

/**
 * Frequência de uso das funções com decaimento: cada abertura soma 1 e a pontuação
 * cai pela metade a cada MEIA_VIDA_DIAS sem uso. Só influencia busca e acessos rápidos;
 * a posição dos itens no menu permanece estática.
 */
export class UsoMenuV2 {
  static readonly CHAVE = 'meucardapio-menu-v2-uso';
  static readonly MEIA_VIDA_DIAS = 14;
  static readonly MAXIMO_REGISTROS = 100;
  private registros: {[id: string]: RegistroUso} = {};

  constructor(private armazenamento?: ArmazenamentoUsoMenuV2 | null, private agora: () => number = Date.now) {
    this.carregar();
  }

  /** `localStorage` do navegador, ou null quando indisponível ou bloqueado. */
  static armazenamentoLocal(): ArmazenamentoUsoMenuV2 | null {
    try { return typeof localStorage === 'undefined' ? null : localStorage; } catch (_) { return null; }
  }

  registrar(id: string): void {
    if (!id) return;
    const atual = this.registros[id];
    this.registros[id] = {vezes: Math.min((atual?.vezes || 0) + 1, 1000), ultimo: this.agora()};
    this.salvar();
  }

  pontuacao(id: string): number {
    const registro = this.registros[id];
    if (!registro) return 0;
    const dias = Math.max(0, this.agora() - registro.ultimo) / DIA_MS;
    return registro.vezes * Math.pow(0.5, dias / UsoMenuV2.MEIA_VIDA_DIAS);
  }

  private carregar(): void {
    try {
      const bruto = this.armazenamento?.getItem(UsoMenuV2.CHAVE);
      const dados = bruto ? JSON.parse(bruto) : {};
      this.registros = {};
      for (const [id, registro] of Object.entries<any>(dados || {})) {
        const vezes = Number(registro?.vezes), ultimo = Number(registro?.ultimo);
        if (vezes > 0 && ultimo > 0) this.registros[id] = {vezes, ultimo};
      }
    } catch (_) {
      this.registros = {};
    }
  }

  private salvar(): void {
    const ids = Object.keys(this.registros).sort((a, b) => this.pontuacao(b) - this.pontuacao(a));
    for (const id of ids.slice(UsoMenuV2.MAXIMO_REGISTROS)) delete this.registros[id];
    for (const id of ids) if (this.pontuacao(id) < 0.05) delete this.registros[id];
    try { this.armazenamento?.setItem(UsoMenuV2.CHAVE, JSON.stringify(this.registros)); } catch (_) {}
  }
}
